import { t } from 'i18next';
import { ApiError } from './ApiError';

export function isForbiddenError(error: Error): error is ForbiddenError {
  return error.constructor === ForbiddenError;
}

export class ForbiddenError extends ApiError {
  static async create(response: Response) {
    const errorResponse = await this.extractError(response);

    const newError = new ForbiddenError(response, errorResponse);

    newError.message =
      (errorResponse.i18n && t(errorResponse.i18n.key, errorResponse.i18n.parameters)) ||
      errorResponse.message ||
      t('Error.Category.Forbidden.message');

    return newError;
  }
}
